import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { useStore } from '../context/StoreContext';
import { useLocale } from '../context/LocaleContext';

const Wishlist = () => {
  const { wishlist } = useStore();
  const { t } = useLocale();

  if (wishlist.length === 0) return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-2xl mx-auto text-center py-20 px-4">
        <div className="w-24 h-24 rounded-full bg-gray-100 mx-auto flex items-center justify-center mb-4">
          <span className="text-5xl">❤️</span>
        </div>
        <h2 className="text-2xl font-black">{t('emptyWishlist')}</h2>
        <p className="text-gray-600 mt-2">{t('emptyWishlistSub')}</p>
        <Link to="/" className="inline-block mt-6 bg-[#22c55e] text-white px-8 py-3 font-bold tracking-wider text-sm hover:bg-[#16a34a] transition">{t('explore')}</Link>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <h1 className="text-2xl md:text-3xl font-black">{t('myWishlist')} <span className="text-gray-500 font-normal text-base">({wishlist.length} {t('items')})</span></h1>
        <div className="h-1 w-16 bg-[#22c55e] mt-2 mb-8"></div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {wishlist.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Wishlist;
